// Dependencias generales
import React from "react";
import { useEffect } from 'react';
import '../../css/common.css';
import '../../css/initialConfigStyle.css';

// Advisory - Fees Analyzer
const PublicFeesAnalyzer = (params) => {
  
  useEffect(() => {   

    document.title = "HELIAS - Asesoramiento: Tarífas de luz"     
    document.querySelector('meta[name="description"]').setAttribute("content", "¿No sabes si tus tarifas de luz son buenas o malas?");

    console.log("Información pública de tarifas cargada.")    

  });

  return (      
      <>
          
          <div id="contenedorInicial" className="vertical gap-06">

            <ul className="default-list">                              
              <p style={{paddingBottom: "15px"}}>Antes de nada debes saber que existen 2 tipos de tarifas:</p>
              <li className="info"><strong>Tarifas fijas:</strong> Con estas tarifas pagarás lo mismo por la luz todos los meses.</li>                
              <li className="info"><strong>Tarifas de mercado regulado / indexadas:</strong> Estas tarifas son variables. Esto implica que cada mes pagarás un precio diferente por la luz en función del precio de mercado. Esto significa que tendrás meses en los que pagarás muy poco y otros en los que pagarás más de lo normal.</li>
            </ul>

            <p><strong>Te recomiendo que optes por tarifas fijas</strong> por ser menos "peligrosas". Las variables hoy en día tienen mucha fluctuación y podrías llegar a tener sorpresas muy desagradables en la factura.</p>

            <p><strong>Evita las tarifas planas</strong>, suelen penalizar en los consumos nocturnos. Elige tarifas en 3 tramos (P1, P2 y P3).</p>

            <p>Dicho esto, hay que reconocer que <strong>actualmente es complejo analizar y recomendar tarifas de luz</strong> ya que, a diferencia de hace unos años, hoy en día exísten muchísimas comercializadoras que ofrecen precios en función del tipo de cliente que buscan. Algunas se centran en dar buenos precios de potencia, otras de energía y otras de venta de excedente. Además ya se han encargado con "desgloses imposibles" de "enrevesar" la factura lo suficiente para asegurarse que cada vez nos cueste más saber cuánto estamos pagando por nuestra luz.</p>                                
            
            <p>Es por esto que lo único que podemos hacer al respecto es decirte los <strong>precios orientativos que a día de hoy se consideran razonables</strong> y tu mism@ veas si estás muy por encima o en términos generales bien.</p>

            <table>
              <tbody>
                <tr className="table-row table-head has-tooltip">
                  <td className="table-cell">
                    <span className="tooltip-trigger-container size-m">
                      <strong style={{color: "orange"}}>POTENCIA</strong>                          
                    </span>
                  </td>
                  <td className="table-cell value size-m adhoc-width">P1</td>
                  <td className="table-cell value size-m adhoc-width">P2</td>
                </tr>
                
                <tr className="table-row vertical-start" id="trPotenciaP1">
                  <td className="table-cell horizontal gap-02">                      
                    <div className="vertical gap-01">
                      <span>Tarifas</span>                          
                    </div>
                  </td>                      
                  <td className="table-cell value text">
                    <div className="vertical gap-01">
                      <span id="valorPotenciaContratadaP1Actual">0,07 €/kW</span>                          
                    </div>
                  </td>
                  <td className="table-cell value text">
                    <div className="vertical gap-01">
                      <span id="valorPotenciaContratadaP1Oferta">0,01 €/kW</span>                          
                    </div>
                  </td>
                </tr>  
              </tbody>
            </table>

            <table>
              <tbody>
                <tr className="table-row table-head has-tooltip">
                  <td className="table-cell">
                    <span className="tooltip-trigger-container size-m">
                      <strong style={{color: "orange"}}>ENERGÍA</strong>                          
                    </span>
                  </td>
                  <td className="table-cell value size-m adhoc-width">P1 (Punta)</td>
                  <td className="table-cell value size-m adhoc-width">P2 (Llano)</td>
                  <td className="table-cell value size-m adhoc-width">P3 (Valle)</td>
                </tr>
                
                <tr className="table-row vertical-start" id="trPotenciaP1">
                  <td className="table-cell horizontal gap-02">                      
                    <div className="vertical gap-01">
                      <span>Tarifas</span>                          
                    </div>
                  </td>                      
                  <td className="table-cell value text">
                    <div className="vertical gap-01">
                      <span id="valorPotenciaContratadaP1Actual">0,15 €/kW</span>                          
                    </div>
                  </td>
                  <td className="table-cell value text">
                    <div className="vertical gap-01">
                      <span id="valorPotenciaContratadaP1Oferta">0,10 €/kW</span>                          
                    </div>
                  </td>
                  <td className="table-cell value text">
                    <div className="vertical gap-01">
                      <span id="valorPotenciaContratadaP1Oferta">0,07 €/kW</span>                          
                    </div>
                  </td>
                </tr>  
              </tbody>
            </table>
            
            <p>Recuerda que <strong>una diferencia de +0,02 €/kWh se consideraría grande</strong> y por tanto cara.</p>

            <p><strong>Evita también las tarifas con % descuento en la energía</strong> ya que suelen ser "cebos" para encubrir tarifas poco competitivas y complicar los cálculos a los usuarios.</p>

            <table>
              <tbody>
                <tr className="table-row table-head has-tooltip">
                  <td className="table-cell">
                    <span className="tooltip-trigger-container size-m">
                      <strong style={{color: "orange"}}>EXCEDENTE</strong>                          
                    </span>
                  </td>
                  <td className="table-cell value size-m adhoc-width"></td>                  
                </tr>
                
                <tr className="table-row vertical-start" id="trPotenciaP1">
                  <td className="table-cell horizontal gap-02">                      
                    <div className="vertical gap-01">
                      <span>Tarifa</span>                          
                    </div>
                  </td>                      
                  <td className="table-cell value text">
                    <div className="vertical gap-01">
                      <span id="valorPotenciaContratadaP1Actual">0,06 €/kW</span>                          
                    </div>
                  </td>
                </tr>  
              </tbody>
            </table>            

            <p><strong>El excedente por debajo de este valor sería mal precio de compra</strong>.</p>
            
            <p>En resumen, para saber si las tarifas que te ofrecen son buenas implicaría recopilar mucha información de tus últimas facturas y cálculos complejos. Es por esto que hemos creado el <strong>"Analizador de tarifas" de Helias</strong>, él solito lee directamente tu consumo de tu medidor y se encarga de revisar periódicamente si tu tarifa es buena o mala. Tu no tienes que hacer nada. También lo analiza para tarifas 3.0. Aquí te dejamos un vídeo para que veas cómo funciona. Recuerda que tienes una <strong>prueba gratuita de 32 días</strong></p>
            
            <div className="video-wrapper">
              <iframe 
                width="100%" 
                height="auto" 
                src="https://www.youtube.com/embed/z32q2Mn78Eo" 
                title="Comunidad solar" 
                frameBorder="0" 
                allow="accelerometer;clipboard-write;encrypted-media;gyroscope;picture-in-picture" 
                allowFullScreen>                
              </iframe>
            </div>

          </div>

      </>
  )
}

export default PublicFeesAnalyzer